module.exports = __webpack_public_path__ + "static/media/ck.04841357.svg";